import { fg } from '@atlaskit/platform-feature-flags/fg';

import { isEmbeddedConfluenceInIframe_DO_NOT_USE } from './isEmbeddedConfluenceInIframe';
import { parseSendToParentProductPayload } from './parseSendToParentProductPayload';
import { requireModule } from './requireModule';
import {
	AI_PLANNER_EMBEDDED_CONFLUENCE_SOURCE,
	PARENT_PRODUCT_MODULE_NAME,
} from './sendToParentProduct';
import type { SendToParentProductPayload } from './sendToParentProduct';

type ParentProductModule = {
	sendToParentProduct: (payload: SendToParentProductPayload) => void | Promise<void>;
};

const getEmbeddedConfluenceSource = (): string | undefined => {
	try {
		return new URL(window.location.href).searchParams.get('embeddedConfluenceSource') ?? undefined;
	} catch {
		return undefined;
	}
};

export const sendToParentProductFromEmbeddedConfluence = async (
	payload: unknown,
): Promise<boolean> => {
	const gateEnabled = fg('embedded_confluence_parent_product_sender');
	if (!gateEnabled) {
		return false;
	}

	const isEmbeddedInIframe = isEmbeddedConfluenceInIframe_DO_NOT_USE();
	if (!isEmbeddedInIframe) {
		return false;
	}

	const embeddedConfluenceSource = getEmbeddedConfluenceSource();
	if (embeddedConfluenceSource !== AI_PLANNER_EMBEDDED_CONFLUENCE_SOURCE) {
		return false;
	}

	const parseResult = parseSendToParentProductPayload(payload);
	if (parseResult.status !== 'valid') {
		return false;
	}

	const module = requireModule<ParentProductModule>(PARENT_PRODUCT_MODULE_NAME);

	if (!module?.sendToParentProduct) {
		return false;
	}

	try {
		await module.sendToParentProduct(parseResult.payload);
		return true;
	} catch {
		return false;
	}
};
